module.exports = __webpack_public_path__ + "menu_0_active_pc.dac943f3.png";